import React, { useEffect, useMemo, useState } from 'react';
import { Progress, View } from "@/views/component/monthRecharge/style";
import Button from "@/views/component/public/button";
import { EButton, EModal } from "@/interface/enum";
import { useMobx } from "@/utils/hooks";
import { useRequest } from "ahooks";
import { ConfDoData, ConfDoEntrysTasks, Mydj, Res } from "@/interface/request.interface";
import { conf, joinAndFinish, mydj } from "@/utils/request";
import { catchModal } from "@/utils/util";
import { Award, Modal } from "@/views/component/modal";


function Index() {
  const operate = useMobx('operate');
  const [count, triggerCount] = useState(0);
  const [task, triggerTask] = useState<ConfDoEntrysTasks[]>([]);

  const { runAsync: confTask } = useRequest<ConfDoData, any>(conf(CONFIG.code.act_weekIntegral), {
    manual: true,
    onSuccess: (data, params) => {
      const list = data.entrys[0].tasks;
      triggerTask(list);
    },
    onError: (error) => {
      const res: Res = JSON.parse(error.message);
      catchModal(EModal['提示'], { message: res.message });
    }
  });
  const { runAsync: mydjData } = useRequest<Mydj, any>(mydj(CONFIG.code.act_weekIntegralCount), {
    manual: true,
    onSuccess: ({ remain }) => {
      triggerCount(remain);
    },
    onError: (error) => {
      const res: Res = JSON.parse(error.message);
      catchModal(EModal['提示'], { message: res.message });
    }
  })
  const { runAsync: getAward } = useRequest(joinAndFinish, {
    manual: true,
    onSuccess: (data, params) => {
      const { taskId } = params[0];

      const idx = task.findIndex((item) => item.id === taskId);
      const award = CONFIG.monthAward.award[idx][1];

      $refPopup.current.open(
        <Modal modalType={EModal['恭喜获得']}>
          <Award name={award.name} awardImg={award.popupAward}/>
        </Modal>
      );

      init();
    },
    onError: (error) => {
      const res: Res = JSON.parse(error.message);
      catchModal(EModal['提示'], { message: res.message });
    }
  });

  useEffect(() => {
    init();
    operate.setMonthRechargeTask(() => init());
  }, []);

  const init = () => {
    confTask();
    mydjData();
  }

  const step = useMemo(() => {
    const list: number[] = CONFIG.monthAward.award.map((item: any) => item[0]);
    return list.reduce((pre, cur, index) => {
      if (count >= cur) {
        return index + 1
      }
      return pre
    }, 0)
  }, [count]);

  const handleGetAward = (bool: boolean, index: number) => {
    if (!bool) {
      return $refPopup.current.open(<Modal
        modalType={EModal['提示']}
        btnType={EButton['弹窗-好的']}
        message={'未达到指定积分'}
        // confirmFn={(props: any) => {
        //   setTimeout(() => {
        //     $refPopup.current.open(<Modal modalType={EModal['充值区服']}/>);
        //   }, 1000)
        //   props.clearAll()
        // }}
      />);
    }

    const taskItem = task[index];

    getAward({
      actCode: CONFIG.code.act_weekIntegral,
      taskId: taskItem.id,
    });
  }

  return <View>
    <p>{CONFIG.monthAward.tip} <span>{count}</span></p>
    <div className={'main'}>
      <Progress step={step}/>
      {CONFIG.monthAward.award.map(([max, data]: any, index: number) => {
        const tip = data.tip.replace('<%>', max);
        const style = count >= max ? 'active' : '';
        const btnStatus = task[index]?.taskStatus || 0;
        return <div className='item' key={index}>
          <img className='award' src={data.awardImg} alt=""/>
          <p>{data.name}</p>
          <p>{tip}</p>
          <div className={`star ${style}`}/>
          <Button type={EButton['月度充值-领取']}
                  status={btnStatus}
                  onClick={() => btnStatus === 0 && handleGetAward(count >= max, index)}
          />
        </div>
      })}
    </div>
  </View>
}

export default Index;
